import { Input } from "@/components/ui/input"
import { Textarea } from "@/components/ui/textarea"
import { FileUploadStep } from "./FileUploadStep"

interface StepInputProps {
  step: {
    type: string;
    field: string;
    placeholder: string;
  };
  value: string;
  uploading?: boolean;
  uploadedFiles?: Array<{ name: string; url: string; }>;
  onInputChange: (value: string) => void;
  onFileChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile?: (file: { name: string; url: string; }) => void;
}

export const StepInput = ({
  step,
  value,
  uploading = false,
  uploadedFiles = [],
  onInputChange,
  onFileChange,
  onRemoveFile
}: StepInputProps) => {
  if (step.type === 'upload' && onFileChange && onRemoveFile) {
    return (
      <FileUploadStep
        value={value}
        uploading={uploading}
        uploadedFiles={uploadedFiles}
        onInputChange={onInputChange}
        onFileChange={onFileChange}
        onRemoveFile={onRemoveFile}
        placeholder={step.placeholder}
      />
    )
  }

  if (step.type === 'textarea') {
    return (
      <Textarea
        value={value}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder={step.placeholder}
        className="w-full min-h-[120px]"
      />
    )
  }

  return (
    <Input
      value={value}
      onChange={(e) => onInputChange(e.target.value)}
      placeholder={step.placeholder}
      className="w-full"
    />
  )
}